  <nav class="navbar navbar-expand-lg  headerutpl">
    <div class="container-fluid">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon" style="color:#fff">||||</span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <img class="img_utpl p-2" src="https://www.utpl.edu.ec/sites/all/themes/utpl/logo.png">
      </div>
    </div>
  </nav>